export default ['Fair', 'Festival'];
